export default __webpack_public_path__ + "static/media/timefreeze.b7e85685.png";